
(function(){
  if(window.__pnbInit) return; window.__pnbInit=true;
  /* PN_BUNDLE_BAR anim v3: 1 gedeelde stand (geen flits bij her-renderen),
     eerste keer start de balk op 0 en loopt vol langs "gratis verzending",
     animatie start pas als de winkelwagen echt in beeld is. */
  var POS={1:30,2:62,3:100}, DELAY=180;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cur=null, target=null, from=0, t0=null, raf=0, running=false, lastLvl=null, dur=950;
  try{var s=sessionStorage.getItem('pnbFill'); if(s!==null) cur=+s; var l=sessionStorage.getItem('pnbLvl'); if(l!==null) lastLvl=+l;}catch(e){}
  function save(){try{sessionStorage.setItem('pnbFill',target);sessionStorage.setItem('pnbLvl',lastLvl);}catch(e){}}
  function ease(t){return t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;}
  function isVis(b){
    var r=b.getBoundingClientRect(); if(r.width===0||r.height===0) return false;
    if(r.right<=8||r.left>=window.innerWidth-8) return false;
    if(b.checkVisibility) return b.checkVisibility({visibilityProperty:true,opacityProperty:true});
    return getComputedStyle(b).visibility!=='hidden';
  }
  function anyVis(){var b=document.querySelectorAll('.pnb');for(var i=0;i<b.length;i++){if(isVis(b[i])) return true;}return false;}
  function paint(w,pop){
    var bars=document.querySelectorAll('.pnb');
    for(var i=0;i<bars.length;i++){
      var bar=bars[i], f=bar.querySelector('.pnb__fill');
      if(f){f.style.transition='none';f.style.width=w.toFixed(2)+'%';}
      var steps=bar.querySelectorAll('[data-step]');
      for(var j=0;j<steps.length;j++){
        var n=steps[j], on=w>=POS[n.dataset.step]-0.4, was=n.classList.contains('is-on');
        if(on!==was){
          n.classList.toggle('is-on',on);
          if(on&&pop&&n.classList.contains('pnb__node')){n.classList.remove('pnb-pop');void n.offsetWidth;n.classList.add('pnb-pop');}
        }
      }
    }
  }
  function shine(){document.querySelectorAll('.pnb__fill').forEach(function(f){f.classList.remove('is-moving');void f.offsetWidth;f.classList.add('is-moving');});}
  function step(ts){
    if(t0===null){
      if(!anyVis()){raf=requestAnimationFrame(step);return;}   /* wacht tot de winkelwagen in beeld is */
      t0=ts+(running?0:DELAY); if(!running) shine();
    }
    running=true;
    var k=Math.min(1,Math.max(0,(ts-t0)/dur));
    cur=from+(target-from)*ease(k);
    paint(cur,true);
    if(k<1){raf=requestAnimationFrame(step);} else {cur=target;running=false;paint(cur,false);}
  }
  function go(tg){
    target=tg; save();
    if(reduce||Math.abs(cur-tg)<0.5){cancelAnimationFrame(raf);running=false;cur=tg;paint(cur,false);return;}
    var wasRunning=running;
    cancelAnimationFrame(raf); from=cur; t0=null; running=wasRunning;
    dur=Math.max(900,Math.min(1400,Math.abs(tg-from)*26));   /* langere afstand = iets langer, voelt natuurlijk */
    paint(cur,false);
    raf=requestAnimationFrame(step);
  }
  function adopt(bar){
    var f=bar.querySelector('.pnb__fill'); if(!f) return;
    var tg=+f.dataset.target, lvl=+bar.dataset.lvl;
    if(cur===null) cur=0;            /* eerste keer: start leeg */
    paint(cur,false);                /* meteen huidige stand overnemen -> geen flits */
    if(lastLvl!==null&&lvl!==lastLvl){var m=bar.querySelector('.pnb__msg');if(m){m.classList.remove('pnb-in');void m.offsetWidth;m.classList.add('pnb-in');}}
    lastLvl=lvl;
    if(tg!==target||Math.abs(cur-tg)>=0.5) go(tg); else if(!running){cur=tg;paint(cur,false);save();}
    requestAnimationFrame(function(){requestAnimationFrame(function(){bar.classList.add('is-live');});});
  }
  function scan(){var b=document.querySelectorAll('.pnb');for(var i=0;i<b.length;i++){if(!b[i].__pnb){b[i].__pnb=1;adopt(b[i]);}}}
  new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){if(ms[i].addedNodes.length){scan();return;}}})
    .observe(document.documentElement,{childList:true,subtree:true});
  scan();
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scan);
})();
